import React from 'react';

export const FichaCadastrarContexto = React.createContext(null);